
angular.module('gallery').directive('trackable', ['$window', function ($window) {
	return {
		restrict: 'A',
		scope: {},
		controller: 'trackCtrl',
		link: function(scope, elem, attr, trackCtrl) {
			var attrNames = Object.keys(attr);
			var meta = {};

			//attrNames: ["$attr", "$$element", "class", "trackable", "metaHeadline"]
			attrNames.forEach(function (value) {
				//update metaHeadline to headline
				if (value.indexOf('meta') > -1) {
					meta[value.replace('meta', '').toLowerCase()] = attr[value];
				}
			});

			//push headline title to meta object and pass it to trackCtrl
			trackCtrl.setMeta(meta);

			angular.element($window).bind("scroll", function() {
				trackCtrl.debounceCheckVisibility();
			});
		}
	};
}]);


